import { Action } from 'redux';

import { UpdateBreadcrumbHref } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';

export interface UpdateBreadcrumbHrefAction extends  Action {
  href: string;
}

export function updateBreadcrumbHref(href: string): UpdateBreadcrumbHrefAction {
  return {
    type: UpdateBreadcrumbHref,
    href
  };
}

export const isUpdateBreadcrumbHrefAction =
  isActionFactory<UpdateBreadcrumbHrefAction>(UpdateBreadcrumbHref);
